import React, { useEffect, useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import {
  DATE_FILTER_POPPER_CLASS,
  DateFilterHeading,
  DateFilterPresets,
  ReadOnlyDateInput,
} from "./DateFilterParts";
const DateRangeComponent = ({
  onDateRangeChange,
  selectedDateRange,
  future_date,
  setCurrentPage,
  usingFor,
}) => {
  const fieldId = React.useId();
  const [isTablet, setIsTablet] = useState(false);
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());
  const [futureDateState, setFutureDate] = useState(new Date());
  // console.log("futureDateState", new Date(futureDateState));

  const handleSearch = () => {
    const formatDate = (date) => {
      return new Intl.DateTimeFormat("en-CA", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      }).format(date);
    };

    const formattedStartDate = formatDate(startDate);
    const formattedEndDate = formatDate(endDate);
    const dateRangeData = {
      start_date: formattedStartDate,
      end_date: formattedEndDate,
    };
    if (usingFor === "resetPagination") {
      setCurrentPage(1);
    }

    onDateRangeChange(dateRangeData);
  };

  const [activeOption, setActiveOption] = useState("Today");

  const setActive = (option) => {
    setActiveOption(option);
  };

  const isActive = (option) => {
    return option === activeOption;
  };

  const setDatesBasedOnOption = (option) => {
    const today = new Date();
    const dayBeforeDay = new Date();
    switch (option) {
      case "Today":
        setStartDate(today);
        setEndDate(today);
        break;
      case "Yesterday":
        const yesterday = new Date();
        yesterday.setDate(today.getDate() - 1);
        setStartDate(yesterday);
        setEndDate(yesterday);
        break;
      case "Last 7 Days":
        const last7Days = new Date();

        dayBeforeDay.setDate(today.getDate());
        last7Days.setDate(today.getDate() - 6);
        setStartDate(last7Days);
        setEndDate(dayBeforeDay);
        break;
      case "Last 30 Days":
        const thirtyDaysAgo = new Date(today);
        thirtyDaysAgo.setDate(today.getDate() - 29);
        dayBeforeDay.setDate(today.getDate());
        setStartDate(thirtyDaysAgo);
        setEndDate(dayBeforeDay);
        break;
      default:
        break;
    }
  };
  // useEffect(() => {
  //   // console.log("inside date range selectedDateRange", selectedDateRange);
  //   let count = 0;
  //   if (selectedDateRange && selectedDateRange && count <= 0) {
  //     // console.log("inside date range selectedDateRange", selectedDateRange);
  //     setStartDate(new Date(selectedDateRange.start_date));
  //     setEndDate(new Date(selectedDateRange.end_date));
  //     // onDateRangeChange({start_date:selectedDateRange.start_date,end_date:selectedDateRange.end_date});
  //     count++;
  //   }
  // }, [selectedDateRange]);
  // console.log("inside date range selectedDateRange", selectedDateRange);
  useEffect(() => {
    const today = new Date();
    let gotFurureDate = new Date();
    future_date &&
      setFutureDate(
        gotFurureDate.setDate(today.getDate() + (parseInt(future_date) + 1))
      );
  }, [future_date]);

  useEffect(() => {
    handleSearch();

    setDatesBasedOnOption(activeOption);
  }, [activeOption]);
  return (
    <div className="q-datarange-bottom-detail-section qv-date-filter">
      <DateFilterHeading />
      <DateFilterPresets
        isActive={isActive}
        onSelect={(option) => {
          setActive(option);
          setDatesBasedOnOption(option);
        }}
      />

      <div className="qv-date-filter__fields">
        <div className="qv-date-filter__field">
          <label htmlFor={`${fieldId}-start`} className="qv-date-filter__label">
            Start Date
          </label>
          <DatePicker
            id={`${fieldId}-start`}
            selected={startDate}
            onChange={(date) => setStartDate(date)}
            selectsStart
            startDate={startDate}
            endDate={endDate}
            maxDate={endDate}
            dateFormat="MM/dd/yyyy"
            showPopperArrow={false}
            popperPlacement="bottom-start"
            popperClassName={DATE_FILTER_POPPER_CLASS}
            customInput={<ReadOnlyDateInput />}
          />
        </div>
        <div className="qv-date-filter__field">
          <label htmlFor={`${fieldId}-end`} className="qv-date-filter__label">
            End Date
          </label>
          <DatePicker
            id={`${fieldId}-end`}
            selected={endDate}
            onChange={(date) => setEndDate(date)}
            selectsEnd
            startDate={startDate}
            endDate={endDate}
            minDate={startDate}
            maxDate={futureDateState ? futureDateState : new Date()} // Set maxDate to today's date
            dateFormat="MM/dd/yyyy"
            showPopperArrow={false}
            popperPlacement="bottom-start"
            popperClassName={DATE_FILTER_POPPER_CLASS}
            customInput={<ReadOnlyDateInput />}
          />
        </div>
        <div className="qv-date-filter__field qv-date-filter__field--action">
          <button type="button" onClick={handleSearch} className="save_btn">
            Search
          </button>
        </div>
      </div>
    </div>
  );
};

export default DateRangeComponent;
